import React, { useState } from 'react';
import { Button, Confirm, ModalContentProps, SemanticShorthandItem } from 'semantic-ui-react';

type BdConfirmProps = {
  actionText: string;
  content?: SemanticShorthandItem<ModalContentProps>;
  confirmButtonText?: string;
  closeOnEscape?: boolean;
  closeOnDimmerClick?: boolean;
  callback: () => void;
};

export const BdConfirm: React.FC<BdConfirmProps> = ({
  actionText,
  content = 'Are you sure?',
  confirmButtonText,
  closeOnEscape = true,
  closeOnDimmerClick = true,
  callback,
}) => {
  const [isOpen, setisOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setisOpen(true)}>{actionText}</Button>
      <Confirm
        content={content}
        open={isOpen}
        closeOnEscape={closeOnEscape}
        closeOnDimmerClick={closeOnDimmerClick}
        onCancel={() => setisOpen(false)}
        onConfirm={() => {
          callback();
          setisOpen(false);
        }}
        confirmButton={confirmButtonText}
      />
    </>
  );
};
